<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
         <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAddFn()">新增字段</el-button>
          </div>
        </zv-table>
    <zv-dialog
      width="400px"
      :title="isEdit ? '修改' : '新增'"
      :showDialog.sync="showFormDialog"
      @close-dialog="closeFormDialog"
    >
      <div slot="content">
        <el-form
          ref="myForm"
          label-width="100px"
          :model="formData"
          :rules="formRules"
          status-icon
        >
          <el-form-item label="栏目名称：" prop="title">
            <el-input v-model="formData.title" :disabled="isEdit ? true: false"></el-input>
          </el-form-item>
          <el-form-item label="取值范围：" prop="article_category_arr">
            <el-select
              class="el-input-width1"
              v-model="formData.article_category_arr"
              filterable
              multiple
            >
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.level + '-' + item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="栏目地址：">
            <el-input v-model="formData.url" filterable></el-input>
          </el-form-item>

          <el-form-item label="启用状态：" prop="status">
            <el-switch
              v-model="formData.status"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="showFormDialog = false">取消</el-button>
        <el-button type="primary" @click="isEdit ? editFn():createFn()">确定</el-button>
      </div>
    </zv-dialog>
  </div>
   </div>
  </div>
</template>

<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service";
export default {
  name: "expertDatabase",
  mixins: [addFormMixin],
  data() {
    let vm = this;
    return {
      addressSelectData: null,
      addressItem: null,
      name: "",
      currentPage: 1,
      totalList: null,
       table: {
        api: api.syndicationList,
        hidePagination: true,
        query: {

        },
        searchData: [
          {
            type: "input",
            model: "syndication_field_config_id",
            placeholder: "栏目id"
          },
          {
            type: "input",
            model: "title",
            placeholder: "栏目名称"
          }
        ],
        columns: [
          {
            title: "栏目名称",
            key: "title",
            minWidth:"100",
          },
          {
            title: "取值范围",
            key: "title",
            minWidth:"100",
            render: (h, ctx) => {
              var arr = ctx.row.article_category_list
              return h('div', arr.map(function (item,index) {
                return h('p',{
                  style: {
                    marginRight: '5px'
                  }
                }, item.id + '-' + item.category_name)
              }))
            }
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "90",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "启用状态",
            minWidth: "80",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status,
                  "inactive-value": 0,
                  "active-value": 1
                },
                on: {
                  change(status) {
                    // vm.doChangeStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEditFn.bind(this, ctx.row)
                  }
                },
                "属性设置"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDetails.bind(this, ctx.row)
                  }
                },

                "字段配置"

              );

              let arr = [];
              arr.push(editBtn);
              arr.push(delBtn);
              return h("span", arr);
            }
          }
        ]
      },
      adddApi: api.syndicationAdd,
      editApi: api.syndicationEdit,
      addSuccessMsg: '添加成功',
      editSuccessMsg: '编辑成功',
      deleteSuccessMsg: '删除成功',
      formRules: {
        title: [{
          required: true,
          message: "栏目名字不能为空",
          trigger: "blur"
        }],
        article_category_arr: [{
          required: true,
          message: "取值范围不能为空",
          trigger: "change"
        }]
      },
      categoryList: ''
    };
  },
  created() {
    this.categoryListFn();
  },
  methods: {
    doDetails(row) {
      let routeData = this.$router.resolve("/data-output/fieldConfiguration?id=" + row.id + "&category_id=" + row.article_category_id);
      window.open(routeData.href, '_blank');
    },
    categoryListFn() {
      api
        .categoryList()
        .then(res => {
          this.categoryList = res.list
        })
        .catch(err => {});
    },
    doEditFn(row) {
      this.isEdit = true
      this.showFormDialog = true
      if(row.article_category_id) {
        this.$set(row,"article_category_arr",row.article_category_id.split(",").map(Number))
      }else {
        // this.$set(row,"article_category_arr",'')
      }
      this.formData = row
    },
    editFn() {
      this.$set(this.formData,"article_category_id",this.formData.article_category_arr.join(","))
      this.submitForm()
    },
    createFn() {
      this.$set(this.formData,"article_category_id",this.formData.article_category_arr.join(","))
      this.submitForm()
    },
    // 查询参数
    // queryData() {
    //   let data = {
    //     name: this.name
    //   };
    //   if (data.name) {
    //     this.getData(data);
    //   } else {
    //     this.getData();
    //   }
    // },

    // 新增数据
    doAddFn() {
      this.formData = {}
      this.isEdit = false
      this.showFormDialog = true
      // this.$set(this.formRulesOri,"article_category_id",this.formData.article_category_arr.join(","))
      // this.formRulesOri.article_category_id = this.formatDate.article_category_id.join(",")
      // console.log(this.formRulesOri.article_category_id)
      // this.formRules = Object.assign({}, this.formRulesOri, this.pwdRule)
    },


    // 删除数据
    deleteData(row) {
      debugger;
      let data = {
        id: row.id
      };
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(data);
        })
        .catch(() => {});
    },

    delete(data) {
      api
        .recordedDelete(data)
        .then(res => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(err => {});
    },

    //改变每页显示数量重新请求数据，重置当前页为第一页
    handleSizeChange(val) {
      let pageSize = { pagesize: val };
      this.getData(pageSize);
    },

    //点击改变当前页
    handleCurrentChange(val) {
      let page = { page: val };
      this.getData(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>